import { Provider } from '@angular/core'

import { AuditLogGridDataResolver } from '@ti/shared/audit/services'

import { FleetAuditGridDataResolver } from './services/grid-data.resolver'

export const provideFleetAudit = (): Provider[] => {
  return [{ provide: AuditLogGridDataResolver, useClass: FleetAuditGridDataResolver }]
}
